(function () {
radaEnquiryNotificationController.$inject = ['$scope'];
    angular
        .module('app.enquiry')
        .component('radaEnquiryNotification', {
            bindings: {
                enquiryUrl : '@',
                enquiryCount : '@'
            }, // components are limited to isolated scope
            templateUrl: '/client/app/enquiry/enquiry-notification.html',
            controller: radaEnquiryNotificationController
        });

/* @ngInject */
function radaEnquiryNotificationController($scope) {
    var vm = this;

    vm.$onInit = function () {
    };

    $scope.$on('product-added', function(event, args) {
        vm.enquiryCount++;
    });

    $scope.$on('product-removed', function(event, args) {
        vm.enquiryCount--;
    });

}
})();